import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { PartialButNot } from 'typescriptUtilityTypes';

import { FieldBehaviorMode } from '@app/queryTyping';

import { FieldRenderData } from '@app/common/configurable-wizards';

import { SsnFieldFragment as SsnField } from '../../queries/queryTyping/all-fields';
import { CFFormField } from '../common/CFFormField';

/** Property-type of the react-hook-form <Controller /> */
type ControllerProps = React.ComponentProps<typeof Controller>;

/** Component props */
export interface SSNFieldComponentProps extends FieldRenderData<SsnField> {
  controllerProps: PartialButNot<ControllerProps, 'render'>;
  name: string;
  error: string;
}

export const SSNFieldComponent: React.FC<SSNFieldComponentProps> = ({
  field,
  name,
  error,
  controllerProps,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={field.sValue || ''}
      shouldUnregister
      rules={{
        required: field.fieldBehaviorMode === FieldBehaviorMode.REQUIRED,
      }}
      {...controllerProps}
      render={(renderProps) => (
        <CFFormField error={error}>
          {controllerProps.render(renderProps)}
        </CFFormField>
      )}
    />
  );
};
